import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalLocationsInput,
  terminalLocationsInputSchema,
} from "./shared/terminalLocations.input";
import {
  type TerminalLocation,
  terminalLocationSchema,
} from "./shared/terminalLocations.output";

/**
 * Metadata for the fetchTerminalLocations endpoint
 */
export const terminalLocationsMeta = {
  functionName: "fetchTerminalLocations",
  endpoint: "/terminalLocations",
  inputSchema: terminalLocationsInputSchema,
  outputSchema: terminalLocationSchema.array(),
  sampleParams: {},
  endpointDescription: "List location information for all terminals.",
} satisfies EndpointMeta<TerminalLocationsInput, TerminalLocation[]>;

/**
 * Fetch function for retrieving location information for all terminals
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalLocationsInput,
  TerminalLocation[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalLocationsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalLocations.endpoints").terminalLocationsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving location information for all terminals
 */
export const fetchTerminalLocations: FetchFactory<
  TerminalLocationsInput,
  TerminalLocation[]
> = fetch;

/**
 * React Query hook for retrieving location information for all terminals
 */
export const useTerminalLocations: HookFactory<
  TerminalLocationsInput,
  TerminalLocation[]
> = useHook;
